<h2 mat-dialog-title class="bgDialogHeader text-center">View Work Order Details
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="col-md-12 dataTable p-0" *ngIf="getWObyEvent">
    <div class="data-table-event-file">
      <table id="accordion" class="table table-bordered">
        <thead>
          <tr>
            <!-- <th scope="col"></th> -->
            <th scope="col">WO#</th>
            <th scope="col">Wo Status</th>
            <th scope="col">Wo Created Date</th>
            <th scope="col">Customer</th>
            <th scope="col">Sub Customer</th>
            <th scope="col">Service</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of getWObyEvent.data">
            <!-- <td></td> -->
            <td scope="col">
              {{data.tSQlKey}}
              <i nbTooltip="View Notes" class="cursor fa fa-sticky-note ml-2" (click)="ViewNote(data.tSQlKey);"
                aria-hidden="true"></i> </td>
            <td scope="col">{{data.woStatus}}</td>
            <td scope="col">{{data.tSQdDateSubmitted}}</td>
            <td scope="col">{{data.customer}}</td>
            <td scope="col">{{data.subCustomer}}</td>
            <td scope="col">{{data.woService}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="col-md-12 border-top" align="end">
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>
